module.exports = __webpack_public_path__ + "media/bell.14a5bc11.wav";